<div class="participant-details-container">
    <div class="main-score">
        <div class="event-header-live" *ngIf="isNewEDPScoreboard; else scores">
            <i class="live-icon"></i>
            <ms-event-timer [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard" [timeValue]="timeValue"> </ms-event-timer>
            <span *ngIf="!!yardDistance && (turn === 1 || turn === 2)">
                &nbsp;• <span class="period-header">{{ yardDistance }}</span></span
            >
        </div>
        <ng-template #scores>
            <div class="header">
                <div class="event-score">
                    <div class="score-container" [ngClass]="{ inactive: vm.eventSuspended }">
                        <ms-score-card [eventId]="event.id" [participant1Score]="vm.score[0]" [participant2Score]="vm.score[1]"> </ms-score-card>
                    </div>
                    <span *ngIf="vm.showPenalties">{{ sitecoreEventDetails.eventDetails.OTEnded }}</span>
                    <ms-event-timer
                        class="period-name"
                        *ngIf="!vm.showPenalties"
                        [live]="event.live"
                        [start]="event.startDate"
                        [scoreboard]="event.scoreboard"></ms-event-timer>
                </div>
            </div>
        </ng-template>

        <ng-container *ngFor="let participant of event.participants; let i = index">
            <div class="participant">
                <ms-participant-image
                    class="participant-logo"
                    [participantImage]="event.participants[i].image"
                    [sportId]="event.sport.id"
                    [shouldRotate]="rotateImage[i]"
                    [showLogoColor]="showLogoColor">
                </ms-participant-image>
                <div class="participant-details">
                    <ms-scoreboard-participant
                        class="participant-info"
                        [showIndicator]="false"
                        [event]="event"
                        [participant]="event.participants[i]"
                        [isNewEDPScoreboard]="isNewEDPScoreboard"
                        [participantInfo]="participantInfos && participantInfos[i]">
                    </ms-scoreboard-participant>
                    <div
                        class="timeout-left"
                        *ngIf="homeTeamTimeouts !== undefined && awayTeamTimeouts !== undefined"
                        [class.has-ranks]="participantInfos && !!participantInfos[i]?.rank">
                        <div class="home-team-time-outs" *ngIf="i === 0 && homeTeamTimeouts !== undefined">
                            <div class="timeout" *ngFor="let timeout of [1, 2, 3]" [ngClass]="{ inactive: timeout > homeTeamTimeouts }"></div>
                        </div>
                        <div class="away-team-time-outs" *ngIf="i === 1 && awayTeamTimeouts !== undefined">
                            <div class="timeout" *ngFor="let timeout of [1, 2, 3]" [ngClass]="{ inactive: timeout > awayTeamTimeouts }"></div>
                        </div>
                    </div>
                    <div class="penalty-shootout-container" *ngIf="vm.showPenaltie && isNewEDPScoreboard">
                        <div class="penalty-shootout-score">
                            <div class="penalty-score">
                                <ms-penalty-shootout class="penalty-shootout" [penalties]="vm.penalties[i]"></ms-penalty-shootout>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>

<ms-period-game-scoreboard-live [scoreboard]="scoreboard" [event]="event" [isNewEDPScoreboard]="isNewEDPScoreboard"> </ms-period-game-scoreboard-live>
